import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapsComponent } from './maps.component';
import { MapsService } from './services/maps.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from '@angular/material';
import { JsonpModule } from '@angular/http';

import { HeatmapModel, HeatmapPoint } from './models/heatmap.model';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MaterialModule,
    JsonpModule
  ],
  providers: [
    MapsService
  ],
  exports: [
    MapsComponent
  ],
  declarations: [MapsComponent]
})
export class MapsModule { }



// WEBPACK FOOTER //
// ./src/app/modules/maps/maps.module.ts